import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function UploadIcon(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement(Path, { d: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12', stroke: props.color, strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' })));
}
export default UploadIcon;
